import { ModelService } from '@app/shared/model-system/model-service';
import { Model } from 'app/shared/model-system/model';
import { Observable } from 'rxjs';

export interface IPropertyOptions {
  remap?: string; // NYI
  requires?: string | string[]; // NYI taking an array of strings
  track?: boolean; // Enable / Disable change tracking
  model?: {
    class: any;
    projection?: string[]; // Definition of partial model strings
  };
  set?<T>(arg: T): T;
  get?<T>(arg: T): T;
  default?(): any; // Set a default value
  // Functions which manipulate data for a model WITHOUT making additional API calls
  deserialize?<T extends Model>(options: { raw?: any; model?: T }): any;
  serialize?<T extends Model>(options: { body?: any; model?: T }): void;
  // Functions to fetch and save asynchronous information from APIs
  load?<T extends Model>(options: { model: T; service?: ModelService<T> }): Observable<any>;
  save?<T extends Model>(options: { model: T; service?: ModelService<T> }): Observable<any>;
}

export function property(options: IPropertyOptions = {}): (target: any, key: string) => void {
  return (target: any, key: string) => {
    if (!target.constructor.attributes) {
      target.constructor.attributes = {};
    }
    target.constructor.attributes[key] = options;

    // Create new property with getter and setter
    Object.defineProperty(target, key, {
      get: (<Model>target).getter(key, options),
      set: (<Model>target).setter(key, options),
      enumerable: true,
      configurable: true
    });
  };
}
